"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var icon_1 = require("./../../icon");
var SideLeft = function (props) {
    var configurationArray = props.configurationArray, checked = props.checked, currentIndex = props.currentIndex, _a = props.moreData, moreData = _a === void 0 ? {} : _a;
    var href = moreData.href, txt = moreData.txt, _b = moreData.extendProps, extendProps = _b === void 0 ? {} : _b;
    return (react_1.default.createElement("div", { className: "left" },
        react_1.default.createElement("div", { className: "left__container" }, configurationArray.map(function (item, index) {
            var _a = item.title, title = _a === void 0 ? '' : _a, _b = item.extendProps, extendProps = _b === void 0 ? {} : _b;
            return (react_1.default.createElement("div", __assign({ className: "left__list", onClick: function () { return checked(index); }, key: "".concat(index).concat(title) }, extendProps),
                react_1.default.createElement("div", { className: (0, classnames_1.default)('logo', {
                        'logo-animation': currentIndex === index,
                    }) },
                    react_1.default.createElement("i", { style: { backgroundImage: "url(".concat(item.imgUrl || '', ")") }, className: (0, classnames_1.default)('icon', {
                            'icon--enter': currentIndex === index,
                            'icon--leave': currentIndex !== index,
                        }) })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)('title', {
                        'title--active': currentIndex === index,
                        'title--leave': currentIndex !== index,
                    }) }, item.title)));
        })),
        txt && (react_1.default.createElement("a", __assign({ href: href, target: "_blank", className: "jump_element", rel: "noreferrer" }, extendProps),
            txt,
            react_1.default.createElement(icon_1.Icon, { name: "arrow-enter", size: 28 })))));
};
exports.default = SideLeft;
//# sourceMappingURL=SideLeft.js.map